var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{style:(`position: relative; z-index: 1;background-image: url(${ _vm.type === 1 ? _vm.bg : _vm.bg2 })`)})
}
var staticRenderFns = []

export { render, staticRenderFns }